import { Accordion as SemanticAccordion } from "semantic-ui-react";

export const Accordion = SemanticAccordion;
Accordion.Content = SemanticAccordion.Content;
Accordion.Title = SemanticAccordion.Title;
